import React from 'react';
import classNames from 'classnames';
import { s_ellipsis } from '@fiverr-private/fit/icons';
import { Icon } from '@fiverr-private/fit';

import styles from './index.module.scss';

const DropdownTrigger = () => (
    <div role="button" aria-label="Open Dropdown" className={classNames(styles.container, 'flex flex-items-center flex-justify-center')}>
        <Icon className={styles.icon}>{s_ellipsis}</Icon>
    </div>
);

export default DropdownTrigger;
